import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { faEnvelope } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";
import { Button } from "@/components/Button/Button";
import { ButtonColor, ButtonSize } from "@/components/Button/types";

export interface ComposeHeaderProps {
	/** Opens the "Compose" prospect picker modal. */
	onCompose: () => void;
}

/**
 * L1 top header for the Compose surface — mirrors `ListContextHeader` (Review/Inbox/Outbox):
 * a compact title bar carrying the page label and the "Compose" action button directly next
 * to it, so Compose follows the same three-tier layout (label → tabs → content) as Review.
 */
export const ComposeHeader: FunctionComponent<ComposeHeaderProps> = ({ onCompose }) => {
	const { t } = useTranslation();

	const label = t("messages.compose.title");

	return (
		<div className="flex w-full flex-shrink-0 items-center gap-2.5 border-b border-border-light bg-white px-4 py-2">
			<span className="text-sm font-semibold text-text whitespace-nowrap">{label}</span>

			<Button
				color={ButtonColor.ACTION_SECONDARY}
				image={<Icon className="mr-2" icon={faEnvelope} />}
				size={ButtonSize.S}
				title={label}
				onClick={onCompose}
			/>
		</div>
	);
};
